import React from "react";

interface HtmlPreviewProps {
  htmlContent: string;
  maxLength?: number;
  style?: React.CSSProperties;
}

export const HtmlPreview: React.FC<HtmlPreviewProps> = ({
  htmlContent,
  maxLength = 200,
  style = {},
}) => {
  if (!htmlContent) return null;

  // Create a temporary div to extract text content for length calculation
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlContent;
  const textContent = tempDiv.textContent || tempDiv.innerText || "";

  // If content is short enough, render the full HTML with formatting
  if (textContent.length <= maxLength) {
    return (
      <div
        className="leading-6 text-text-secondary m-0 mb-3 text-sm break-words max-w-full"
        style={style}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  }

  // For longer content, truncate text content at word boundaries
  const words = textContent.split(" ");
  let truncatedText = "";
  let currentLength = 0;

  for (const word of words) {
    if (
      currentLength + word.length + (currentLength > 0 ? 1 : 0) >
      maxLength - 3
    ) {
      // -3 for "..."
      break;
    }
    truncatedText += (currentLength > 0 ? " " : "") + word;
    currentLength += word.length + (currentLength > 0 ? 1 : 0);
  }

  // Append "..." if the text was actually truncated
  const displayText =
    truncatedText.length < textContent.length
      ? truncatedText + "..."
      : truncatedText;

  return (
    <div
      className="leading-6 text-text-secondary m-0 mb-3 text-sm break-words max-w-full"
      style={style}
    >
      {displayText}
    </div>
  );
};
